"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoizeFunction = void 0;
const p_memoize_1 = __importDefault(require("p-memoize"));
const expiry_map_1 = __importDefault(require("expiry-map"));
const CACHE_TTL = 1000 * 60 * 1; // 1 minute
/**
 * Memoizes the result of a function for 1 minute.
 * This function should not be overused and only be used in context where
 * the same to be memoized function is called more than once as part of the same
 * request and refactoring is difficult.
 */
const memoizeFunction = (func, ttl = CACHE_TTL) => (0, p_memoize_1.default)(func, { cache: new expiry_map_1.default(ttl), cacheKey: (args) => JSON.stringify(args) });
exports.memoizeFunction = memoizeFunction;
//# sourceMappingURL=memoize.js.map